// ----------------------------------------------------------------------

export default function Container(containerId: string) {
  return {
    MuiContainer: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {},
      },
    },
  };
}
